import { render, staticRenderFns } from "./inventory-history.vue?vue&type=template&id=1f73ecbe"
import script from "./inventory-history.vue?vue&type=script&lang=js"
export * from "./inventory-history.vue?vue&type=script&lang=js"
import style0 from "./inventory-history.vue?vue&type=style&index=0&id=1f73ecbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports